import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a90286c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wapper" }
const _hoisted_2 = { class: "ps-2 d-flex align-center" }
const _hoisted_3 = { class: "flex-1 d-flex justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "range"
}
const _hoisted_5 = { key: 1 }

import { withDefaults, ref, reactive, watch } from 'vue';
import { DatePicker } from 'v-calendar';
import { format, isValid } from 'date-fns';
import { AtomInput, CalendarIcon } from '@/components/atoms';
import { formatDateToString } from '@/utils/formatDate';

interface IProps {
  color: string;
  icon: string;
  size: string;
  dateRange: { start: any; end: any };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomDatePicker',
  props: {
    color: { default: 'warning' },
    icon: { default: 'mdi-alert-circle' },
    size: { default: 'small' },
    dateRange: {}
  },
  setup(__props: any) {

const props = __props;
const date = ref(new Date());
date.value.setDate(new Date().getDate() + 35);
const range = reactive({
  start: null,
  end: null,
});

watch(
  () => props.dateRange,
  () => {
    range.start = props.dateRange.start;
    range.end = props.dateRange.end;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_AtomButton = _resolveComponent("AtomButton")!

  return (_openBlock(), _createBlock(_unref(DatePicker), {
    "is-range": "",
    modelValue: range,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((range) = $event)),
    columns: 2
  }, {
    default: _withCtx(({ inputEvents }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _mergeProps(_toHandlers(inputEvents.start, true), {
          class: ["d-flex align-center h-100", [range.start && range.end ? 'justify-space-between' : '']]
        }), [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(CalendarIcon))
          ]),
          _createElementVNode("div", _hoisted_3, [
            (range.start && range.end)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("p", null, "Inicio: " + _toDisplayString(_unref(formatDateToString)(_ctx.dateRange.start)), 1),
                  _createElementVNode("p", null, "Fim: " + _toDisplayString(_unref(formatDateToString)(_ctx.dateRange.end)), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "Range de data"))
          ]),
          (range.start && range.end)
            ? (_openBlock(), _createBlock(_component_AtomButton, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
              () => {
                _ctx.$emit('cleanRange');
              }
            ),
                class: "pe-2 cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("X")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 16)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})